import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import PropTypes from 'prop-types';

import './SetListPanel.css';

import { buildClass } from '../../../libs/classes';
import { useSet } from '../../../hook/useSet';
import { setType, setTypeInfo } from '../../../hoc/MtgProvider';
import WorkspacePanel, { WorkspacePanelHead } from '../../../components/WorkspacePanel/WorkspacePanel';
import { SimpleSelectLabeled } from '../../../components/SimpleComponents/SimpleSelect';
import SimpleInput from '../../../components/SimpleComponents/SimpleInput';
import { buildRoute } from '../AllCardsPage.Route';

const MONTHS_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const SetListPanel = () => {
	const navigate = useNavigate();

	const { sets, activeSet } = useSet();
	const [filterName, setFilterName] = useState('');
	const [filterType, setFilterType] = useState(setType.all);

	const filterSetType = (id) => {
		if (filterType === setType.all) return 1;
		if (sets[id].set_type === filterType) return 1;

		return 0;
	};
	const filterSetName = (id) => {
		if (filterName === '') return 1;
		if (sets[id].name.toLowerCase().includes(filterName.toLowerCase())) return 1;

		return 0;
	};

	const sortSets = (id1, id2) => {
		return sets[id1].released_at < sets[id2].released_at ? 1 : -1;
	};
	const formatReleaseDate = (dateStr) => {
		let dateObjectFromString = new Date(dateStr);
		return String(dateObjectFromString.getUTCFullYear()) + ' ' + MONTHS_NAMES[dateObjectFromString.getUTCMonth()];
	};

	const handleSelectSet = (set) => {
		let setUrl = buildRoute(set);
		navigate(setUrl);
	};

	const buildSetItemClass = (set) => {
		return buildClass('set-item').add(activeSet && set?.id === activeSet?.id, 'active');
	};

	const handleFilterChange = (event) => {
		setFilterName('');
		setFilterType(event.target.value);
	};

	return (
		<WorkspacePanel className="set-list-panel">
			<WorkspacePanelHead title="Magic the Gathering Sets" />
			<div className="subhead">
				<div className="filter-type">
					<SimpleSelectLabeled label="Show:" value={filterType} onChange={handleFilterChange}>
						{Object.keys(setType).map((key) => (
							<option key={key} title={setTypeInfo[setType[key]]?.description || ''} value={setType[key]}>
								{setTypeInfo[setType[key]]?.title}
							</option>
						))}
					</SimpleSelectLabeled>
				</div>
				<div className="spacer" />
				<div className="filter-name">
					<SimpleInput
						placeholder="Filter by name..."
						title="Set name filter"
						value={filterName}
						onChange={(e) => setFilterName(e.target.value)}
					/>
				</div>
			</div>
			<div className="content scrollable">
				{Object.keys(sets)
					.filter((id) => filterSetType(id))
					.filter((id) => filterSetName(id))
					.sort((id1, id2) => sortSets(id1, id2))
					.map((setId) => (
						<div
							className={buildSetItemClass(sets[setId])}
							key={setId}
							onClick={() => handleSelectSet(sets[setId])}
						>
							<div className="set-release-date">{formatReleaseDate(sets[setId].released_at)}</div>
							<div className="set-name">
								{sets[setId].name} [{sets[setId].code.toUpperCase()}]
							</div>
							<div className="set-type" title={setTypeInfo[sets[setId].set_type]?.description}>
								{sets[setId].set_type}
							</div>
							<div className="set-count">{sets[setId].card_count}</div>
						</div>
					))}
			</div>
		</WorkspacePanel>
	);
};

SetListPanel.propTypes = {};

export default SetListPanel;
